var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14373 19.7816V16.7148C8.14372 15.9376 8.77567 15.3062 9.55844 15.3013H12.4326C13.2189 15.3013 13.8563 15.9341 13.8563 16.7148V16.7148V19.7727C13.8563 20.4468 14.404 20.9946 15.0829 20.9995H17.0438C17.9596 21.0018 18.8388 20.6423 19.4872 20.0002C20.1356 19.3581 20.5 18.4863 20.5 17.577V8.86536C20.5 8.1309 20.1721 7.43422 19.6046 6.96301L12.943 1.67378C11.7785 0.748634 10.1154 0.77852 8.98539 1.7449L2.46701 6.96301C1.87274 7.42033 1.51755 8.11907 1.5 8.86536V17.5681C1.5 19.4632 3.04738 20.9995 4.95617 20.9995H6.87229C7.19917 21.0018 7.51349 20.8746 7.74547 20.6459C7.97746 20.4173 8.10793 20.1062 8.10792 19.7816H8.14373Z",
    stroke: "#AAACAE",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.07b247cff4ce12b54ca9323b15be92bd.svg";
export { ForwardRef as ReactComponent };